import React, { useEffect, useState } from "react";
import { Button, Col, FloatingLabel, Form, Modal, Row, Spinner } from "react-bootstrap";
import PrivateApi from "../../services/PrivateApiService";
import { FaCheckCircle } from "react-icons/fa";
import EmployeeStage from "../anlage/new_anlage/EmployeeStage";
import { useAuthState } from "../../context/AuthContext";
import { useQueryClient } from "react-query";


/**
 * 
 * @param {props} show boolean to show/hide modal
 * @param {props} setShow boolean setter to set show
 * @param {props} elv object elv
 * 
 * @returns html modal
 */
const MissingInvoiceModal = ({show, setShow, elv}) => {

    const API = new PrivateApi();
    const queryClient = useQueryClient();
    const {user, contactPerson} = useAuthState();
    const [stage, setStage] = useState("default");
    const [monthSelect, setMonthSelect] = useState("");
    const [yearSelect, setYearSelect] = useState("");
    const [description, setDescription] = useState("");
    const [fieldErrors, setFieldErrors] = useState({});

    const months = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'Novembar', 'Dezembar'];
    const years = [new Date().getFullYear(), new Date().getFullYear() - 1, new Date().getFullYear() -2];


    useEffect(() => {
        if (show === true) {
            if (user.x_is_house_management === true) {
                if (contactPerson === undefined || contactPerson === null) {
                    return setStage("contact") ;
                }
            }
            setStage("default");
        }
    }, [show])


    // handler for closing
    const closeHandler = () => {
        setStage("default");
        setFieldErrors({});
        setMonthSelect("");
        setYearSelect("");
        setDescription("");
        setShow(false);
    }


    // handler to send data to backend
    const sendDataHandler = () => {
        var temp = {};
        if (monthSelect === "") temp.monthSelect = true;
        if (yearSelect === "") temp.yearSelect = true;
        if (Object.keys(temp).length > 0) {
            return setFieldErrors(temp);
        }

        setStage('loading');
        var data = {elv: elv, month: monthSelect, year: yearSelect, comment: description};

        if (user.x_is_house_management && contactPerson !== null && contactPerson !== undefined) {
            data['contact'] = contactPerson;
        }

        API.post_Abrechnung_missing(data)
            .then(() => {
                queryClient.invalidateQueries("GET_ELVS_DETAILS_QUERY");
                setStage("success");
            })
            .catch(() => {
                setStage("error");
            })
    }

    return (
        <Modal show={show} onHide={() => closeHandler()}>
            <Modal.Header closeButton>
                <Modal.Title>Fehlende Abrechnung</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    stage === 'contact'?
                        <EmployeeStage setShow={setShow} setStage={setStage} /> :

                    stage === 'default'?
                        <div className="mt-2">
                            <p>Ich kann eine Abrechnung zu diesem Energieliefervertrag nicht finden. Bitte leiten Sie eine Recherche ein.</p>
                            <br />
                            <Row className="mb-3">
                                <Col xs="6">
                                    <Form.Select
                                        value={monthSelect}
                                        onChange={e => {setMonthSelect(e.target.value); setFieldErrors({})}}
                                        isValid={monthSelect !== ""}
                                        isInvalid={fieldErrors.monthSelect}
                                    >
                                        <option value="">Monat</option>
                                        {months.map(m => (
                                            <option key={m} value={m}>{m}</option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col xs="6">
                                    <Form.Select
                                        value={yearSelect}
                                        onChange={e => {setYearSelect(e.target.value); setFieldErrors({})}}
                                        isValid={yearSelect !== ""}
                                        isInvalid={fieldErrors.yearSelect}
                                    >
                                        <option value="">Jahr</option>
                                        {years.map(y => (
                                            <option key={y} value={y}>{y}</option>
                                        ))}
                                    </Form.Select>
                                </Col>
                            </Row>

                            <FloatingLabel label="Nachricht">
                                <Form.Control 
                                    value={description}
                                    onChange={e => setDescription(e.target.value)}
                                    isValid={description !== ""}
                                    as="textarea" 
                                    placeholder="Nachricht" 
                                    style={{height: "100px"}}
                                />
                            </FloatingLabel>
                        </div>:
                    stage === 'loading'?
                        <div className="text-center">
                            <p>Daten werde am <span className="text-energo">ENERGO</span> übermittelt...</p>
                            <Spinner animation="border" className="text-energo"/>
                        </div>:
                    stage === 'success'?
                        <div className="text-center">
                            <FaCheckCircle size={50} className="text-energo" /> 
                            <p className="mt-3">
                                Wir haben Ihre Anfrage bekommen und melden uns, sobald wir die Abrechnung erhalten haben.
                            </p>
                        </div>:
                    stage === 'error'?
                        <div>
                            <p className="text-danger">
                                Fehler aufgetreten, bitte versuchen Sie später nochmal.
                            </p>
                        </div>
                :null}
            </Modal.Body>
            <Modal.Footer>
                {
                    stage === 'default' ? 
                        <div>
                            <Button onClick={() => closeHandler()} variant="warning">Abbrechen</Button>
                            &nbsp;
                            <Button onClick={() => sendDataHandler()} className="btn-energo">Absenden</Button>
                        </div>:
                    stage === 'success' ?
                        <div>
                            <Button onClick={() => closeHandler()} className="btn-energo">Ok</Button>
                        </div>:
                    stage === 'error' ?
                        <Button onClick={() => closeHandler()} className="btn-energo">Ok</Button>
                    :null
                }
            </Modal.Footer>
        </Modal>
    )
}

export default MissingInvoiceModal;